import type { FC, PropsWithChildren, ReactNode } from "react";
import React from "react";

import { H, HSection } from "@react/foundation/heading-level";

interface PageViewProps {
  readonly actions?: ReactNode;
  readonly icon: ReactNode;
  readonly subtitle: string;
  readonly title: string;
}

export const PageView: FC<PropsWithChildren<PageViewProps>> = ({
  actions,
  children,
  icon,
  subtitle,
  title,
}) => (
  <HSection
    heading={
      <div className="mb-8 flex items-center justify-between">
        <div className="flex items-center gap-3">
          <div
            className={`
              flex size-9 items-center justify-center rounded-lg bg-primary/10 text-primary
              [&_svg]:size-5
            `}
          >
            {icon}
          </div>
          <div>
            <H className="text-xl font-semibold tracking-tight">{title}</H>
            <p className="text-sm text-muted-foreground">{subtitle}</p>
          </div>
        </div>
        {actions}
      </div>
    }
  >
    {children}
  </HSection>
);
